package one.healthium.log_food.data.image

class JsImageReader : ImageReader {
    override fun readBytes(uri: String): ByteArray {
        throw UnsupportedOperationException("Image reading is not supported on JS")
    }
}
